import React from 'react'

import Body from '@dashboard/components/Body'
import Header from '@dashboard/components/Header'
import LoadingBar from '@dashboard/components/LoadingBar'

import css from './styles.module.scss'

interface OwnProps {}
interface State {}

export default class LoadingState extends React.Component<OwnProps, State> {
  render() {
    return (
      <div className={css.container}>
        <Header>
          <div className={css.overview}>
            <div className={css.left}>
              <LoadingBar
                height={176}
                width={'176px'}
                margin={'0'}
                radius={'100%'}
              />
            </div>
            <div className={css.right}>
              <LoadingBar height={36} width={'50%'} margin={'16px 0 0'} />
              <LoadingBar height={20} width={'25%'} margin={'4px 0 0'} />
              <LoadingBar height={20} width={'100%'} margin={'22px 0 0'} />
              <LoadingBar height={20} width={'75%'} margin={'4px 0 0'} />
              <LoadingBar height={36} width={'50%'} margin={'22px 0 0'} />
            </div>
          </div>
        </Header>
        <Body>
          <div className={css.filler} />
        </Body>
      </div>
    )
  }
}
